const shadows = {
  lineShadow: '0px 1px 1px rgba(33, 21, 81, 0.08)',
  popup: '0 17px 26px rgba(33, 21, 81, 0.1)',
  dropShadowPopup: 'drop-shadow(0px 10px 26px rgba(33, 21, 81, 0.15))',
  taskMenuHover: '0px 17px 26px rgba(33, 21, 81, 0.1)',
  taskBox: '0px 1px 2px rgba(33, 21, 81, 0.08)',
}

export default shadows
